import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { enumsEN } from '@trace-8/trace8-schema';
import { commonEN, editInvestorPageEN, errorsEN, generateSignaturePacketPageEN } from './locales/en';

i18n.use(initReactI18next).init({
  // this object defines translations => scalable practices recommend a folder structure of language/namespace - initially we will just have a en folder
  resources: {
    en: {
      enums: enumsEN,
      common: commonEN,
      errors: errorsEN,
      generateSignaturePacketPage: generateSignaturePacketPageEN,
      editInvestorPage: editInvestorPageEN
    }
  },
  lng: 'en', // initial language set - there is a provided method to change this dynamically => i18n.changeLanguage('fr')
  fallbackLng: 'en', // language fallback if no translation is located in the selected language
  ns: ['enums'], // translation namespaces (Each namespace corresponds to a JSON file)
  defaultNS: 'enums', // default namespace if one is not specified in the component using
  interpolation: {
    escapeValue: false // technically react automatically escapes all variables in JSX by default but their library suggests setting this => https://www.i18next.com/translation-function/interpolation#unescape
  }
});

export default i18n;
